import { SignInOptions } from 'next-auth/react';
import { getHomeLoansDashboardRuntimeConfig } from 'src/services/config/getHomeLoansDashboardRuntimeConfig';
import { zillowSignIn } from './utils/zillowSignIn/zillowSignIn';

/**
 * Since multiple coomponents and business logic paths can cause a sign in attempt,
 * it can be difficult to debug why session logins were attempted. To address this, this function
 * requires that a justification for performing a login is provided, which is then logged to the console in lower
 * environments for debugging.
 * @param justification - why the session should be started
 */
export const handleSessionStart = (justification: string, signInOptions: SignInOptions = {}) => {
    const { publicRuntimeConfig } = getHomeLoansDashboardRuntimeConfig();
    if (publicRuntimeConfig.isLowerEnvironment) {
        // eslint-disable-next-line no-console
        console.info('Application Session Started - ', justification);
    }
    zillowSignIn(signInOptions);
};
